module.exports = __webpack_public_path__ + "static/media/cnx-pay-Bancontact.f34056e2.svg";